import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HashRouter as Router, Link} from 'react-router-dom';
import axios from 'axios';
import Q from 'q';
import uuid from 'uuid';
import Modal from 'react-modal';
import RouterBar from '../components/routerbar';
import Timer from '../components/timer';
import {updateAppState} from '../actions/actions';
import { ToastContainer } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';

import { SessionExpireModal, TimeOutModal, ConnectionErrorModal } from '../components/utils/utilcomponents';

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalArray: [],
			resizecount: 0,
			fixed_style_body : {}
		};

		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.reloadpage = this.reloadpage.bind(this);
		this.mainappRef = this.mainappRef.bind(this);
		this.initializeResponse = this.initializeResponse.bind(this);
		this.pageInitializeCallback = this.pageInitializeCallback.bind(this);
	}

	componentDidCatch(error, info) {
		console.log(error, info);
	}

	initializeResponse(response) {
		axios.get('/api/initialize').then((secresponse) => this.pageInitializeCallback(secresponse));
	}

	pageInitializeCallback(response) {
		let tempAppObj = {}
		for(var prop in response.data)
			tempAppObj[prop] = response.data[prop];

		this.props.updateAppState(tempAppObj);
	}

	closeModal(modal) {
		let key = -1;
		this.state.modalArray.map((item, index) => {
			if(item.id == modal.id)
				key = index;
		});
		if(this.state.modalArray.length > -1)
			this.state.modalArray.splice(key, 1);
		this.setState({
			modalArray :  [...this.state.modalArray]	
		});
	}

	openModal(modal) {
		setTimeout(() => {
			modal.id = uuid.v1();
			modal.isOpen = true;
			if(modal.dontShow)
				this.setState({
					modalArray :  [...this.state.modalArray]
				});
			else
				this.setState({
					modalArray :  [...this.state.modalArray, modal]
				});
		}, 0);
	}

	renderModal(index) {
  		if(!this.state.modalArray[index])
  			return null;

		let modal = this.state.modalArray[index];
		return (
			<Modal
				isOpen={modal.isOpen}
				onRequestClose={() => {modal.confirmModal ? null : this.closeModal(modal)}}
				shouldCloseOnOverlayClick={modal.confirmModal ? false : true}
				ariaHideApp={false}
				aria={{
				labelledby: "heading",
				describedby: "full_description"}}
				className={modal.className.content}
				overlayClassName={modal.className.overlay}>
				{modal.render(() => this.closeModal(modal))}
				{this.renderModal(index + 1)}
			</Modal>
		);
	}

	componentWillMount() {
		axios.interceptors.response.use((response) => {
		    return response;
		}, (error) => {
			if(!error)
				return Promise.reject(error);
			if(error.response && error.response.status == 401) {
				/*this.openModal({
					render: (closeModal) => {
						return <SessionExpireModal closeModal={closeModal} />
					},
					className: {
						content: 'react-modal-custom-class-40',
						overlay: 'react-modal-overlay-custom-class'
					}, confirmModal: true
				});
				return Promise.reject(error);*/
				window.location='/login';
			} if(error.response && error.response.status == 504) {
				this.openModal({
					render: (closeModal) => {
						return <TimeOutModal closeModal={closeModal} />
					},
					className: {
						content: 'react-modal-custom-class-40',
						overlay: 'react-modal-overlay-custom-class'
					}, confirmModal: true
				});
				return Promise.reject(error);
			} else if (error.toString() == 'Error: Network Error' || (error.response && error.response.status == 0)) {
				this.props.updateAppState('pageloaderFlag', true);
				let connectionErrorCallback = () => {
					this.props.updateAppState({
						pageloaderFlag : false,
						usepageloaderFlag : true
					});
					//return deferred.reject();
				}
				this.openModal({
					render: (closeModal) => {
						return <ConnectionErrorModal callback={connectionErrorCallback}  closeModal={closeModal} />
					},
					className: {
						content: 'react-modal-custom-class-40',
						overlay: 'react-modal-overlay-custom-class'
					}
				});
				return Promise.reject(error);
			} else {
				return Promise.reject(error);
			}
		});
		this.initializeResponse();
	}

	componentDidMount(){
		let { manpowercount } = this.state;
		let fixed_style_body = {};
		if($(window).outerWidth() > 767) {
			fixed_style_body = {
				marginTop: `${this.props.isModal ? '0' : ((document.getElementsByClassName('header').length > 0 ? document.getElementsByClassName('header')[0].clientHeight : 0) + 3)}px`,
				marginBottom: `${this.props.isModal ? '0' : (document.getElementsByClassName('header').length > 0 ? (document.getElementsByClassName('header')[0].clientHeight - 40) : 40)}px`
			}
		}

		this.setState({fixed_style_body});
		setTimeout(() => {
			this.updateWindowSize();
		}, 300);
		
	}

	reloadpage() {
		window.location.reload();
	}

	mainappRef(node) {
		window.addEventListener('resize', (evt) => {
			this.setState({ resizecount: this.state.resizecount++ });
		});
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowSize);
	}

	updateWindowSize = () => {
		this.setState((prevState) => {
			return {
				duplicatereload: !prevState.duplicatereload
			}
		});
	}

	createServiceRequest(evt) {
		evt.preventDefault();
		let win = window.open("/spa#/createservicecallmanual", '_blank');
		if (!win) {
			this.props.openModal(modalService['infoMethod']({
				header : 'Warning',
				body : "Popup Blocker is enabled! Please add this site to your exception list.",
				btnName : ['Ok']
			}));
		}
	}
	
	render() {
		if(!this.props.app.companydetails){
			return null;
		}

		let { companydetails } = this.props.app;
		let { fixed_style_body } = this.state;

		let pageheight = $(window).outerHeight() - $('.header').outerHeight();

		let logo1 = '',logo2 = '',logo3='';
		if(this.props.app.companyid == 1 && ['Mumbai'].includes(this.props.app.branch)){
			logo1 = 'logo_demo1.png';
			logo2 = 'clientlogo.png';
		}else if(this.props.app.companyid == 1 && ['Mumbai New'].includes(this.props.app.branch)){
			logo1 = 'logo.png';
			logo2 = 'clientlogo.png';
		}else if(this.props.app.companyid == 3 && companydetails.name ==  'Government of Jammu & Kashmir'){
			logo1 = 'clientlogo_hexamed.png';
			logo2 = 'logo_hexamed.png';
		}
		else if(this.props.app.companyid == 4){
			logo1 = 'clientlogo_hexamed.png';
			logo2 = 'logo_all.png';
		}
		else if(this.props.app.companyid == 1 && this.props.app.branch == 'Jharkhand'){
			logo1 = 'clientlogo_hexamed.png';
			logo2 = 'logo_all.png';
		}
		else if(this.props.app.companyid == 3 && companydetails.name !=  'Government of Jammu & Kashmir'){
			logo1 = 'clientlogo_hexamed.png';
			logo2 = 'logo_ladakh.png';
		}else if(this.props.app.companyid == 1 && this.props.app.branch == 'Tata'){
			logo2 = 'clientlogo.png';
		}else if(this.props.app.companyid == 1 && this.props.app.branch == 'Arunachal Pradesh'){
			logo1 = 'clientlogo_hexamed.png';
			logo2 = 'logo_all.png';
		}else if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura'){
			logo1 = 'clientlogo_hexamed.png';
			logo2 = 'logo_all.png';
		}
		else if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura New'){
			logo1 = 'clientlogo_hexamed.png';
			logo2 = 'logo_all.png';
		}
		else if(this.props.app.companyid == 1 && this.props.app.branch == 'Mizoram'){
			logo1 = 'clientlogo_mizoram.png';
			logo2 = 'logo_mizoram.png';
		}
		else if(this.props.app.companyid == 1 && this.props.app.branch == 'Nagaland'){
			logo1 = 'clientlogo_nagaland.png';
			logo2 = 'logo_nagaland.png';
		}
		else if(this.props.app.companyid == 1 && this.props.app.branch == 'Sysmex'){
			logo1 = 'clientlogo.png';
			logo2 = 'logo_sysmex.png';
		}
		else if(this.props.app.companyid == 1 && this.props.app.branch == 'Goa'){
			logo1 = 'clientlogo_goa.png';
			logo2 = 'logo_all.png';
			logo3 = 'logo_goa.png';
		}
		else if(this.props.app.companyid == 1 && this.props.app.branch == 'BMC BLR'){
			logo1 = 'clientlogo_bangalore.png';
			logo2 = 'logo_bangalore.png';
		}
		else if(this.props.app.companyid == 6){
			logo1 = 'clientlogo_radimage.png';
		}
		else if(this.props.app.companyid == 7){
			logo1 = 'clientlogo_dmiher_du_wardha.png';
			logo2 = 'logo_dmiher_du_wardha.png';
		}
		else if(this.props.app.companyid == 8){
			logo1 = 'clientlogo_aiims_bhopal.png';
			logo2 = 'logo_aiims_bhopal.png';
		}
		else if(this.props.app.companyid == 9){
			logo1 = 'clientlogo.png';
			logo2 = 'logo_ladakh.png';
		}

		let sopsrc = '';
		if(this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch)) sopsrc = './help_mumbai.pdf';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Jharkhand') sopsrc = './help_jharkhand.pdf';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Arunachal Pradesh') sopsrc = './help_arunachalpradesh.pdf';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura') sopsrc = './help_tripura.pdf';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura New') sopsrc = './help_tripura.pdf';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Mizoram') sopsrc = './help_mizoram.pdf';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Nagaland') sopsrc = './help_nagaland.pdf';
		if(this.props.app.companyid == 3 && companydetails.name ==  'Government of Jammu & Kashmir') sopsrc = './help_jk.pdf';
		if(this.props.app.companyid == 3 && companydetails.name !=  'Government of Jammu & Kashmir') sopsrc = './standard_operating_procedure_hexamed.pdf';
		if(this.props.app.companyid == 4) sopsrc = './help_chhattisgarh.pdf';
		if(this.props.app.companyid == 7) sopsrc = '';

		let headerSecondLine = '';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Sysmex') headerSecondLine = `Sysmex Equipment Maintenance Services`;
		else if(this.props.app.companyid == 8) headerSecondLine = `Comprehensive Maintenance of Bio-Medical Equipment`;
		else headerSecondLine = `Biomedical Equipment Maintenance Services`;

		let callcreation = false;
		if(window.location.href.indexOf('/spa#/createservicecall') > -1) callcreation = true;

		return (
			<div className="dummy">
				<ToastContainer className={'toast-wrapper'} icon={false} />
					<Router>
					<div>
						<div className='row header no-gutters'>
							<div className='col-md-12'>
								<div className='d-flex justify-content-between header-container'>
									<div className='d-flex align-items-center'  style={{flex: '1'}}>
										{
											(logo1 && !(this.props.app.companyid == 1 && this.props.app.branch == 'Tata') && !this.props.app.isDemoDashboard) ? 
												<div style={{width:'200px', height:'90px'}}><img className="marginleft-20" style={{width:'100%', height:'100%',objectFit: 'contain'}} src={`../images/${logo1}`}/> </div>
												: null
										}
										{
											(logo2 && !this.props.app.isDemoDashboard) ?
												<div style={{width:'150px', height:'90px'}}><img className="marginleft-30" style={{width:'100%', height:'100%',objectFit: 'contain'}} src={`../images/${logo2}`}/></div>
												: null
										}
										{
											(logo3 && !this.props.app.isDemoDashboard) ? 
												<div style={{width:'125px', height:'90px'}}><img className="marginleft-20" style={{width:'100%', height:'100%',objectFit: 'contain'}} src={`../images/${logo3}`}/></div>
												: null
										}
									</div>
									<div className = ' text-center header-title' style={{lineHeight: '2', flex: '1'}}>
										<span>{companydetails.name}</span><br/>
										<span>{ headerSecondLine }</span><br/>
										<span style={{color: "#008060",fontSize: "15px",fontWeight: "600",fontFamily: "Poppins",fontStyle: "normal"}}>Project Start Date - {companydetails.date}</span>
									</div>
									<div style={{flex: '1'}}>
										{
											(!this.props.app.isDemoDashboard) ?
												<div className = 'text-right header-title' style={{marginRight:'20px'}}>
													<div>
														{
															(!this.props.app.hideLoginPage && !callcreation) ? <a className="marginright-15" href="/logout">Logout</a> : null
														}
														{
															(this.props.app.companyid != 6 && !callcreation) ? <a className="marginright-15" title="Help" href={sopsrc} target="_blank" ><span className="fa fa-question-circle-o fa-lg"></span></a> : null
														}
														{ (companydetails.tollfreeno) ? <div><span style={{color: "#FC001E"}}>Toll Free : {companydetails.tollfreeno} </span></div> : null }
													</div>
													{ (companydetails.hotlineno) ? <div><span style={{color: "#FC001E"}}>Hotline :  {companydetails.hotlineno}</span><br/></div> : null }
													<div><Timer/></div>
													{
														(this.props.app.showManualCallCreation && !callcreation) ? <a style={{float:"right"}} href="" onClick={this.createServiceRequest}>Create Repair Call</a> : null
													}
												</div>
											: (<div className = 'text-right header-title' style={{marginRight:'20px'}}>
												<Timer/>
											</div>)
										}
									</div>
								</div>
							</div>
						</div>
						<div className="container-fluid" style = {{height : `${pageheight}px`,maxHeight : `${pageheight}px`,overflow:"auto",paddingBottom:"10px"}}>
							<div className='row'>
								<div className= "col-md-12">
									<div id="main" ref={this.mainappRef}>
										<RouterBar openModal={this.openModal} closeModal={this.closeModal} createOrEdit={this.createOrEdit} updateBookMark={this.updateBookMark} />
										<div>{this.renderModal(0)}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Router>
			</div>
		);
	}
}


export default connect((state)=>{
	return {app : state.app}
}, (dispatch) => {
	return bindActionCreators({updateAppState}, dispatch);
})(App);



// WEBPACK FOOTER //
// ./public/react/containers/app.js